import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { Box, Grid } from "@mui/material";
import { styled } from "@mui/system";
import { Row, Col } from "react-bootstrap";
import { Empty, message, Modal } from "antd";
import { callRecruitmentAIAction } from "common/aiChatStream";
import SecondSubMenu from "./SecondSubMenu";
import { Select } from "antd";
import { CALL_API } from "common/API";
import { find, get, isEmpty, map } from "lodash";
import { connect } from "react-redux";
import { toggleProcessingModal } from "redux/actions";
import { bindActionCreators } from "redux";
import { ButtonOutlined } from "reusableComponent/UIButtons";
import { useTranslation } from "react-i18next";

const CustomizeTabPanel = styled(TabPanel)(({ theme }) => ({
  "&.root": {
    padding: 0,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "400px",
    },
  },
  width: "100%",
  padding: 0,
}));

const VerticalTab = styled(Tab)({
  textTransform: "none",
  color: "#636980",
  textAlign: "left",
  alignItems: "flex-start",
  "&.MuiTabs-indicator": {
    width: "0px",
  },
  "&.Mui-selected": {
    borderRadius: "15px",
    border: "none",
    background: "#E3E8FC",
    color: "#1F243B",
  },
});

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

function VerticalTabs({
  candidateList,
  processList,
  jobList,
  getData,
  activeTab = "",
  processValue,
  setShowComponent,
  onboardCandidate,
  selectedItem,
  movetoChange,
  goBack,
  updateProcessingModal,
  index,
}) {
  const { t } = useTranslation();

  const [localCandidateList, setLocalCandidateList] = React.useState([]);
  const [value, setValue] = React.useState(index || 0);
  const [selectedCandidate, setSelectedCandidate] = React.useState(
    localCandidateList[value]
  );
  const [loading, setLoading] = React.useState(false);
  const [draftingEmail, setDraftingEmail] = React.useState(false);
  const [draftedEmail, setDraftedEmail] = React.useState(null);

  const EMAIL_TYPE_LABELS = {
    invite: "Interview invite",
    offer: "Offer",
    reject: "Rejection",
  };

  const handleDraftEmail = async (emailType) => {
    setDraftingEmail(true);
    try {
      const result = await callRecruitmentAIAction("draft_email", {
        candidateId: selectedCandidate?.candidateId,
        emailType,
      });
      if (result.error) {
        message.error(result.error);
        return;
      }
      setDraftedEmail({ emailType, ...result });
    } catch (error) {
      console.error("Draft email error:", error);
      message.error("Could not draft the email. Please try again.");
    } finally {
      setDraftingEmail(false);
    }
  };

  const copyDraftedEmail = () => {
    if (!draftedEmail) return;
    navigator.clipboard.writeText(`Subject: ${draftedEmail.subject}\n\n${draftedEmail.body}`);
    message.success("Copied to clipboard");
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setSelectedCandidate(localCandidateList[newValue]);
  };

  React.useEffect(() => {
    if (activeTab.toString() === "1") {
      const filteredCandidates = candidateList.filter(
        (candidate) =>
          candidate.currentStatus === processValue?.toString() &&
          candidate?.jobId === selectedItem?.jobId
      );
      setLocalCandidateList(filteredCandidates);
      setSelectedCandidate(filteredCandidates[value]);
    } else {
      setLocalCandidateList(candidateList);
      setSelectedCandidate(candidateList[value]);
    }
  }, [processValue, candidateList]);

  const handleSelectChange = async (value) => {
    const updatedCandidate = {
      ...selectedCandidate,
      currentStatus: value,
    };
    setSelectedCandidate(updatedCandidate);

    const updatedLocalCandidateList = localCandidateList.map((candidate) => {
      if (candidate.candidateId === selectedCandidate?.candidateId) {
        return updatedCandidate;
      } else {
        return candidate;
      }
    });

    setLocalCandidateList(updatedLocalCandidateList);
    updateProcessingModal(true);
    await CALL_API(
      `recruitment/candidate/${selectedCandidate?.candidateId}`,
      "patch",
      { currentStatus: value }
    );
    updateProcessingModal(false);
    // goBack();
    getData();
  };

  const moveToTalentPool = async () => {
    updateProcessingModal(true);
    await CALL_API(
      `recruitment/candidate/${selectedCandidate?.candidateId}`,
      "patch",
      { talentPoolStatus: true }
    );
    updateProcessingModal(false);
    message.success(t("Moved to Talent Pool"));
    getData();
    goBack();

    const updatedLocalCandidateList = localCandidateList.filter(
      (candidate) => candidate.candidateId !== selectedCandidate.candidateId
    );
    setLocalCandidateList(updatedLocalCandidateList);
    setSelectedCandidate(updatedLocalCandidateList[0]);
    setValue(0);
    setLoading(false);
  };

  const getProcess = () => {
    const process = find(processList, {
      processId: selectedCandidate?.processId,
    });
    if (process) {
      const steps = get(process, "steps", []);
      return steps;
    }
    return [];
  };

  const transformedSteps = map(getProcess(), (step) => {
    const key = Object.keys(step)[0];
    const value = step[key];
    return { value: key, label: value };
  });

  const tabheight = { maxHeight: "80vh" };

  return (
    <Grid container>
      {localCandidateList?.length > 0 && (
        <>
          <Grid item xs={24} sm={24} md={4} lg={2}>
            <Tabs
              orientation="vertical"
              variant="scrollable"
              value={value}
              onChange={handleChange}
              aria-label="Vertical tabs example"
              style={tabheight}
            >
              {localCandidateList?.map((item, index) => (
                <VerticalTab
                  key={index}
                  label={`${item?.firstName} ${item?.lastName}`}
                  {...a11yProps(index)}
                  className="mt-3"
                />
              ))}
            </Tabs>
          </Grid>

          <Grid
            item
            xs={24}
            sm={24}
            md={8}
            lg={10}
            sx={{ borderLeft: 2, borderColor: "divider" }}
          >
            {selectedCandidate && (
              <CustomizeTabPanel value={value} index={value}>
                <div>
                  <Row>
                    <Col lg={5} sm={12}>
                      <h6 className="fw-semibold">
                        <strong>{`${selectedCandidate?.firstName} ${selectedCandidate?.lastName}`}</strong>
                      </h6>
                    </Col>
                    <Col lg={7} sm={12}>
                      <div className="text-end">
                        {activeTab?.toString() !== "4" && (
                          <ButtonOutlined
                            onClick={moveToTalentPool}
                            loading={loading}
                          >
                            {t("Add to Talent Pool")}
                          </ButtonOutlined>
                        )}
                        <span className="mx-2">
                          <ButtonOutlined
                            primary
                            onClick={() => {
                              setShowComponent("onboard");
                              onboardCandidate(selectedCandidate);
                            }}
                          >
                            {t("On Board")}
                          </ButtonOutlined>
                        </span>
                        {activeTab?.toString() !== "4" && (
                          <Select
                            value={t("Move to")}
                            onChange={(val) => {
                              handleSelectChange(val);
                            }}
                            options={transformedSteps}
                          />
                        )}
                        <span className="mx-2">
                          <Select
                            value={draftingEmail ? t("Drafting...") : `✦ ${t("Draft Email")}`}
                            disabled={draftingEmail}
                            onChange={(val) => handleDraftEmail(val)}
                            options={Object.entries(EMAIL_TYPE_LABELS).map(([value, label]) => ({ value, label: t(label) }))}
                          />
                        </span>
                      </div>
                    </Col>
                    <SecondSubMenu
                      item={selectedCandidate}
                      jobList={jobList}
                      processList={processList}
                      getProcess={getProcess}
                    />
                  </Row>
                </div>
                <Modal
                  title={draftedEmail ? `✦ ${t("AI-drafted email")} — ${t(EMAIL_TYPE_LABELS[draftedEmail.emailType])}` : ""}
                  open={Boolean(draftedEmail)}
                  onCancel={() => setDraftedEmail(null)}
                  footer={[
                    <ButtonOutlined key="copy" onClick={copyDraftedEmail}>
                      {t("Copy")}
                    </ButtonOutlined>,
                    <ButtonOutlined key="close" primary onClick={() => setDraftedEmail(null)}>
                      {t("Close")}
                    </ButtonOutlined>,
                  ]}
                >
                  {draftedEmail && (
                    <div>
                      <div style={{ fontSize: 11, color: "#636980", marginBottom: 4 }}>{t("To")}</div>
                      <div style={{ marginBottom: 12 }}>{draftedEmail.candidateEmail}</div>
                      <div style={{ fontSize: 11, color: "#636980", marginBottom: 4 }}>{t("Subject")}</div>
                      <div style={{ marginBottom: 12, fontWeight: 600 }}>{draftedEmail.subject}</div>
                      <div style={{ fontSize: 11, color: "#636980", marginBottom: 4 }}>{t("Message")}</div>
                      <div style={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}>{draftedEmail.body}</div>
                    </div>
                  )}
                </Modal>
              </CustomizeTabPanel>
            )}
            {isEmpty(selectedCandidate) && (
              <div className="mt-5">
                <Empty />
              </div>
            )}
          </Grid>
        </>
      )}
      {localCandidateList?.length === 0 && (
        <div className="w-100 text-center mt-5">
          <Empty />
        </div>
      )}
    </Grid>
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateProcessingModal: toggleProcessingModal,
    },
    dispatch
  );

export default connect(null, mapDispatchToProps)(VerticalTabs);
